import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, SearchX } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <>
      <Navbar />
      <div className="not-found-page">
        <div className="not-found-content">
          <div className="not-found-icon">
            <SearchX size={64} color="#29ABE2" strokeWidth={1} />
          </div>
          <h1 className="not-found-code">404</h1>
          <h2 className="not-found-title">Page Not Found</h2>
          <p className="not-found-text">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="not-found-actions">
            <Link to="/" className="hero-btn-primary">
              <ArrowLeft size={18} />
              Back to Home
            </Link>
            <Link to="/shop" className="hero-btn-secondary">
              Browse Products
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFoundPage;